import { Component, OnInit, ViewChild, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { Router } from "@angular/router";
import { MatPaginator, MatSort } from '@angular/material';
import { DataSource } from '@angular/cdk/collections';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';

import { Employee } from '../../models/Employee';
import { EmployeeService } from './../../services/employee.service';

@Component({
  selector: 'app-employee-search',
  templateUrl: './employee-search.component.html',
  styleUrls: ['./employee-search.component.css'],
  providers: [EmployeeService],
  encapsulation: ViewEncapsulation.None
})
export class EmployeeSearchComponent implements OnInit {
  displayedColumns = ['idemployee', 'first_name', 'last_name'];
  employeeDatabase: EmployeeDao | null;
  dataSource: EmployeeDataSource | null;
  @Input() nested: boolean = false;
  @Output() notify: EventEmitter<Employee> = new EventEmitter<Employee>();


  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  public scrollbarOptions = {
    axis: 'y',
    scrollButtons: {
      enable: true
    },
    theme: "dark",
    advanced: {
      updateOnContentResize: true
    }
  }
  constructor(private router: Router, public employeeService: EmployeeService) { }

  edit() {
    this.router.navigate(['/employee/' + this.employeeService.selected]);
  }

  choose() {
    console.log('chooooose', this.employeeService.selected)
    this.employeeService.getEmployee(this.employeeService.selected).subscribe(result => {
      console.log(result)
      if (result.success) {
        this.notify.emit(new Employee(result.employee));
      }
    })

  }

  add() {
    this.router.navigate(['/employee/new']);
  }

  highlight(row) {
    this.employeeService.selected = row.idemployee;
  }

  ngOnInit() {
    this.employeeDatabase = new EmployeeDao(this.employeeService);
    this.dataSource = new EmployeeDataSource(this.employeeDatabase!, this.paginator, this.sort);
  }

}

export interface EmployeeApi {
  items: Employee[];
  total_count: number;
}

// export interface EmployeeItem {
//   first_name: string;
//   last_name: string;
// }

export class EmployeeDao {

  constructor(private employeeService: EmployeeService) { }

  getEmployeeItems(sort: string, order: string, page: number, pageSize: number): Observable<EmployeeApi> {
    console.log('================= getEmployeeItems');
    console.log('sort: ', sort);
    console.log('order: ', order);
    console.log('page: ', page + 1);

    this.employeeService.selected = -1;

    let opt = {
      page: page + 1,
      limit: pageSize,
      sort: sort,
      order: order
    }

    return this.employeeService.search(opt).map(response => response as EmployeeApi);
  }
}

export class EmployeeDataSource extends DataSource<Employee> {
  // The number of issues returned by github matching the query.
  resultsLength = 0;
  // isLoadingResults = false;
  // isRateLimitReached = false;
  isLoadingResults: boolean = true;
  constructor(
    private employeeDatabase: EmployeeDao,
    private paginator: MatPaginator,
    private sort: MatSort) {
    super();
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<Employee[]> {
    const displayDataChanges = [
      this.sort.sortChange,
      this.paginator.page
    ];

    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    return Observable.merge(...displayDataChanges)
      .startWith(null)
      .switchMap(() => {
        this.isLoadingResults = true;

        return this.employeeDatabase.getEmployeeItems(
          this.sort.active,
          this.sort.direction,
          this.paginator.pageIndex,
          this.paginator.pageSize);
      })
      .map(data => {
        console.log(data)
        // Flip flag to show that loading has finished.
        this.isLoadingResults = false;
        // this.isRateLimitReached = false;
        this.resultsLength = data.total_count;

        return data.items;
      })
      .catch((e) => {

        this.isLoadingResults = false;
        // Catch if the GitHub API has reached its rate limit. Return empty data.
        // this.isRateLimitReached = true;
        return Observable.of(null);
      });
  }

  disconnect() { }
}



// WEBPACK FOOTER //
// ./src/app/components/employee-search/employee-search.component.ts